export class ErrorHelpers {
  private static extractMsg (error: string | Error): string {
    if (error instanceof Error) {
      return error.message
    }
    return error
  }

  public static convertToString(errorOrErrors: string | Error): string

  public static convertToString(errorOrErrors: (string | Error)[]): string[]

  public static convertToString (
    errorOrErrors: string | Error | (string | Error)[],
  ): string | string[] {
    if (Array.isArray(errorOrErrors)) {
      const errorsMsgList = errorOrErrors.map(ErrorHelpers.extractMsg)
      return errorsMsgList
    }
    const errorMsg = ErrorHelpers.extractMsg(errorOrErrors)
    return errorMsg
  }
}
